import styled from 'styled-components'

export const GrowthStyled = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	width: 100%;
`
